import type { QueryKey } from "@tanstack/react-query";

import type { QueryAssetAttachmentsParams } from "./asset-attachments.types";

/**
 * Query-key factory for asset attachments. Mirrors assetValidationQueryKeys.
 * Its own module, like evidencePhotosQueryKeys, so a consumer that only
 * invalidates never imports the hooks and drags in a barrel cycle.
 * The Attachments tab's upload and delete invalidate `all`, which also
 * refetches an open flyout's reports (one extra request, harmless).
 */
export const assetAttachmentQueryKeys = {
  all: ["asset-attachments"] as QueryKey,
  list: (query: QueryAssetAttachmentsParams): QueryKey => [
    "asset-attachments",
    "list",
    query,
  ],
};
